export default "__VITE_ASSET__CayS3t9Q__"